<template>
	<div class="d-flex">
		<div>
			<avatar />
		</div>
		<content-editable-input
			v-model="comment"
			emojis
			ref="content-editable-input"
			@enterPress="addComment"

			class="d-flex flex-grow-1 mx-3"
		/>
		<div>
			<v-btn depressed color="primary" class="h-100" @click="addComment" :loading="sending">
				{{ $vuetify.lang.t('$vuetify.views.wall.post.publish') }}
			</v-btn>
		</div>
	</div>
</template>

<script>
import Avatar from "@/components/Avatar";
import ContentEditableInput from "@/components/items/ContentEditableInput";
import { mapActions } from "vuex";
export default {
	name: "PostCommentAdd",
	components: {
		Avatar,
		ContentEditableInput
	},
	props: {
		post: {
			type: Number,
			required: true
		},
		parent: {
			type: Number,
			default: null
		},
		placeholder: {
			type: String
		}
	},
	data () {
		return {
			sending: false,
			comment: null
		}
	},
	methods: {
		...mapActions('wall', [
			'setComment'
		]),
		async addComment() {
			if (this.comment && !this.sending) {
				this.sending = true
				let comment = {
						parent_id: this.parent,
						mention_user_ids: this.comment.mentions,
						content: this.comment.content,
						post: {
							id: this.post
						}
					}

				await this.setComment({ comment })
				this.$emit('input', true)

				// if (await this.setComment({ comment })) {
				// 	// this.$refs['content-editable-input'].clearComment()
				// }
				this.sending = false
			}
		},
	},
}
</script>

